// @ts-expect-error JS library
import vClickOutside from 'click-outside-vue3'

export default defineNuxtPlugin(
  // @ts-expect-error JS library
  (NuxtApp) => NuxtApp.vueApp.use(vClickOutside),
)
